// extracted by mini-css-extract-plugin
export var container = "_bj-0";
export var containerTopRight = "_bj-1";